export type FieldType = 'string' | 'number' | 'boolean' | 'stringlist' | 'tokens';

export type SpecField = { path: string; label: string; type: FieldType };

export const SPEC_FIELDS: Record<string, SpecField[]> = {
  dataset: [
    { path: 'name', label: 'Dataset name', type: 'string' },
    { path: 'mode', label: 'Mode', type: 'string' },
    { path: 'sql_config.version', label: 'Version', type: 'string' },
    { path: 'sql_config.dataset_type', label: 'Dataset type', type: 'string' },
    { path: 'sql_config.filters.species', label: 'Species', type: 'stringlist' },
    { path: 'sql_config.filters.robot_type', label: 'Robot type', type: 'tokens' },
    { path: 'sql_config.filters.tags.all_of', label: 'Tags (all of)', type: 'tokens' },
    { path: 'sql_config.filters.tags.exclude', label: 'Tags (exclude)', type: 'tokens' },
  ],
  train: [
    { path: 'pipeline.s3_config.prefix_name', label: 'Species prefix', type: 'string' },
    { path: 'pipeline.s3_config.model_type', label: 'Model type', type: 'string' },
    { path: 'deploy_target', label: 'Deploy target', type: 'string' },
    { path: 'training.batch_size', label: 'Batch size', type: 'number' },
    { path: 'training.num_epochs', label: 'Epochs', type: 'number' },
    { path: 'training.patience', label: 'Patience', type: 'number' },
  ],
  test: [
    { path: 'model.mlflow.species', label: 'Species', type: 'string' },
    { path: 'model.mlflow.model_type', label: 'Model type', type: 'string' },
    { path: 'model.mlflow.version', label: 'Model version', type: 'string' },
    { path: 'model.selection_method', label: 'Model selection', type: 'string' },
    { path: 'pipeline.s3_config.prefix_name', label: 'S3 prefix', type: 'string' },
  ],
  autolabel: [],
  inference_comparison: [],
  mcap: [],
};
